// Places the eastern-most marker near the right viewport edge in overview mode.
export const MAP_MARKER_RIGHT_EDGE_TARGET_RATIO = 0.80;
// Hard safety cap so aggressive framing never sends map center too far west.
export const MAP_MAX_WESTWARD_SHIFT_DEGREES = 28;

export const getResponsiveRightEdgeShiftConfig = (mapWidthPx) => {
  const width = Number.isFinite(mapWidthPx) && mapWidthPx > 0 ? mapWidthPx : 1200;

  // Keep east-coast markers visually prominent while preserving room for controls and gutters.
  const rightOverlayGutterPx = width < 640 ? 116 : width < 768 ? 108 : width < 1024 ? 96 : width < 1280 ? 84 : 72;
  const targetRatio = Math.min(
    MAP_MARKER_RIGHT_EDGE_TARGET_RATIO,
    Math.max(0.72, 1 - (rightOverlayGutterPx / width))
  );

  const shiftScale = width < 640 ? 0.24 : width < 768 ? 0.3 : width < 1024 ? 0.44 : width < 1280 ? 0.62 : width < 1536 ? 0.78 : 1;

  return {
    targetRatio,
    maxWestwardShiftDegrees: MAP_MAX_WESTWARD_SHIFT_DEGREES * shiftScale,
  };
};
